import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../utils/propUtils';
import VeltCommentsSidebarFilterItem from '../VeltCommentsSidebarFilterItem/VeltCommentsSidebarFilterItem';
import VeltCommentsSidebarFilterName from '../VeltCommentsSidebarFilterName/VeltCommentsSidebarFilterName';
import VeltCommentsSidebarFilterSearch from '../VeltCommentsSidebarFilterSearch/VeltCommentsSidebarFilterSearch';
var VeltCommentsSidebarFilterInvolved = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-filter-involved-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarFilterInvolved.Name = VeltCommentsSidebarFilterName;
VeltCommentsSidebarFilterInvolved.Item = VeltCommentsSidebarFilterItem;
VeltCommentsSidebarFilterInvolved.Search = VeltCommentsSidebarFilterSearch;
export default VeltCommentsSidebarFilterInvolved;
